












import Vue from 'vue'

import Header from '@/components/organisms/Header.vue'
import Footer from '@/components/organisms/Footer.vue'
import Loading from '@/components/molecules/Loading.vue'
import PageTopButton from '@/components/atoms/PageTopButton.vue'

type Data = {
  title: string;
};

export default Vue.extend({
  name: 'App',
  components: {
    Header,
    Footer,
    Loading,
    PageTopButton
  },
  data (): Data {
    return {
      title: process.env.VUE_APP_TITLE
    }
  }
})
